// General helper functions

export const general = {
    singleToDoubleDigit(number: number) {
        return number < 10 ? `0${number}` : `${number}`;
    },
    dateToString: (date: Date) => {
        return `${general.singleToDoubleDigit(date.getDate())}.${general.singleToDoubleDigit(date.getMonth() + 1)}.${date.getFullYear()}`;
    },
    groupBy: (collection: Array<any>, property: string) => {
        var i = 0, val, index,
            values = [], result = [];
        for (; i < collection.length; i++) {
            val = collection[i][property];
            index = values.indexOf(val);
            if (index > -1)
                result[index].push(collection[i]);
            else {
                values.push(val);
                result.push([collection[i]]);
            }
        }
        return result;
    },
    getBreedAccess: (authUser: any, selectedBreed: string | undefined) => {
        let councilAccesses = authUser?.userdata?.COUNCIL_ACCESS;
        if (!councilAccesses || !selectedBreed) return undefined;
        return councilAccesses.find((i: any) => i.BREED_ID == selectedBreed)?.ACCESSLEVEL;
    },
    userHasRole: (authUser: any, role: string) => {
        if (!authUser) return false;
        let userRole = authUser?.userdata?.ROLE;
        if (!userRole) return false;
        if (userRole == role) return true;
        return false;
    },
    /**
     * Resolves the entry URL tag from:
     * 1. ?entry=<tag> query param (localhost / testing)
     * 2. forvaltning-<tag>.aninova.no (production)
     * 3. aninovatest-<tag>.norsvin.no (test)
     */
    getEntryTag: (searchParams: URLSearchParams): string | null => {
        const queryTag = searchParams.get('entry');
        if (queryTag) return queryTag;

        const hostname = window.location.hostname;

        const prodMatch = hostname.match(/^forvaltning-(.+)\.aninova\.no$/);
        if (prodMatch) return prodMatch[1];

        const testMatch = hostname.match(/^aninovatest-(.+)\.norsvin\.no$/);
        if (testMatch) return testMatch[1];

        return null;
    }
}